<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer004">
<p class="header ParaOverride-1" id="_idParaDest-1"><span class="Character-Style-1 _idGenCharOverride-1"><a id="_idTextAnchor000"></a>Other Books From Islandport Press: </span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-6">Shoutin’ Into The Fog</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-7">By Thomas Hanna</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-6">The Cows Are Out!</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-7">Trudy Chambers Price</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-6">Nine Mile Bridge</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-7">Helen Hamlin</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-6">Whatever It Takes</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-7">May Davidson</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-6">In Maine</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-7">By John N. Cole</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-6">Old Maine Woman</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-7">Glenna Johnson Smith</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-6">My Life in The Maine Woods</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-7">Annette Jackson</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-6">Christmas in Maine</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-7">Robert P. Tristram Coffin</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-7">These and other Maine books available at:</span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="Character-Style-1 CharOverride-7">www.islandportpress.com</span></p>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-2" id="_idContainer005">
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer006">
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// All_is_calm_interior_epub1.vue?6de7adfa